import { setUserFeatureNotAvailableDialogOpen } from "@/pages/applicationMainSlice";
import { useAppDispatch, useAppSelector } from "@/store/hooks";

export const useUserFeatureNotAvailableDialog = (): [boolean, (newValue: boolean) => void] => {
  const dispatch = useAppDispatch();

  const isUserFeatureNotAvailableDialogOpen = useAppSelector(
    (state) => state.applicationMain.isUserFeatureNotAvailableDialogOpen,
  );

  const onSetUserFeatureNotAvailableDialogOpen = (newValue: boolean): void => {
    dispatch(setUserFeatureNotAvailableDialogOpen(newValue));
  };

  return [isUserFeatureNotAvailableDialogOpen, onSetUserFeatureNotAvailableDialogOpen];
};
